import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { listenForNotificationOpens } from '../lib/notificationLinks';

// A tapped notification, with Twinden already open, arrives as a message from
// the service worker and is routed in place: no reload, history intact
// (issue #21). Mounted once, inside the router.
export function useNotificationOpens() {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }
    return listenForNotificationOpens(
      navigator.serviceWorker,
      (to, options) => navigate(to, options),
      () => ({
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        // React Router keeps an entry's state under `usr`.
        state: (window.history.state as { usr?: unknown } | null)?.usr ?? null,
      })
    );
  }, [navigate]);
}
